import React, { createContext, useContext, useState } from 'react';
import { ModelName, DEFAULT_MODEL, AVAILABLE_MODELS } from '../utils/modelConfig';

interface ModelContextType {
  selectedModel: ModelName;
  setSelectedModel: (model: ModelName) => void;
  availableModels: typeof AVAILABLE_MODELS;
}

const ModelContext = createContext<ModelContextType | undefined>(undefined);

export const ModelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedModel, setSelectedModel] = useState<ModelName>(DEFAULT_MODEL);

  return (
    <ModelContext.Provider value={{ selectedModel, setSelectedModel, availableModels: AVAILABLE_MODELS }}>
      {children}
    </ModelContext.Provider>
  );
};

export const useModel = () => {
  const context = useContext(ModelContext);
  if (context === undefined) {
    throw new Error('useModel must be used within a ModelProvider');
  }
  return context;
};
